import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, IconButton, Dialog, useMediaQuery, Container } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import {
  backsidebackgrounddesktop,
  backsidebackgroundmobile,
  gardientline,
  masterlayout,
  bulletpoint,
} from "../../../assets";

const images = ["https://dprstorage.b-cdn.net/kolla/kollgroup-floorplate.jpg"];

const MasterLayout: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [showText, setShowText] = useState(true); // State to toggle animation
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    const interval = setInterval(() => {
      setShowText((prev) => !prev); // Toggle text visibility
    }, 2000); // Change every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        backgroundImage: `url(${backsidebackgrounddesktop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflow: "hidden",
        px: { xs: 0, md: 2 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          color: "white",
          py: { xs: 6, md: 4 },
          px: { xs: 1, md: 2 },
        }}
      >
        <Container maxWidth="xl">

        <Box sx={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "24px" , md: "28px" },
              background: "linear-gradient(90deg, #bf742c, #fff8da, #c58038)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
          Master Layout
          </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", my: 1, width: "100%" }}>
              <img src={gardientline} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "100%", maxWidth: "900px", marginRight: 0 }} />
            </Box>
          </Box>

        <Box sx={{display: "flex",  alignItems: "center",mt: 1,}}>
          <Typography
            variant="body1"
            sx={{ fontSize: isMobile ? "12px": "16px", maxWidth: "800px", fontFamily: "LEMON MILK", mx: "auto", lineHeight: 1.6, my: 1 , textAlign: "center", fontWeight: "300", color : "#d3d3d3", letterSpacing: 1, opacity: 0.8 }}
          >
            Every detail has been thoughtfully designed to create a balance between comfort, convenience, & elegance.
          </Typography>
        </Box>
          
        <Box sx={{ position: "relative", display: "flex", justifyContent: "center", flexDirection : isMobile ? "column" : "row", alignItems: "center", mt: 1, mb: 1 }}>
        <Box sx={{ width : isMobile ? "100%" : "60%", display: "flex", justifyContent: "center", alignItems: "center",}}>
          <Box sx={{ position: "relative", display: "flex", justifyContent: "center", mt: 1 , height: isMobile ?"450px" :"550px", width: "auto" }}>
            <img
              src={"https://dprstorage.b-cdn.net/kolla/zoom%20NEW.png"}
              alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group"
              onClick={() => setIsOpen(true)}
              style={{
                cursor: "pointer",
                height: "100%",
                borderRadius: 8,
                transition: "transform 0.3s",
              }}
            />
            {/* Animated Text */}
            <Typography
              variant="body1"
              onClick={() => setIsOpen(true)} // Open Lightbox on text click
              sx={{
                position: "absolute",
                bottom: "-30px",
                fontSize: isMobile ? "12px" : "16px",
                fontFamily: "LEMON MILK",
                fontWeight: "400",
                color: "#d3d3d3",
                textAlign: "center",
                letterSpacing: 1,
                cursor: "pointer",
                animation: showText
                  ? "fadeInBounce 2s ease-in-out"
                  : "fadeOut 2s ease-in-out",
              }}
            >
              Click to View
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: isMobile ? "100%" : "40%", display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
          {!isMobile ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              {[
          "Spacious Residences",
          "Centralized Amenities",
          "Green Landscapes",
          "Ample Parking",
          "Easy Navigation",
              ].map((feature, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1, mt: 4 }}>
            <img src={bulletpoint} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "30px", height: "30px", marginRight: "8px" }} />
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                fontFamily: 'LEMON MILK',
                fontWeight: "400",
                color: "#d3d3d3",
                letterSpacing: 1,
              }}
            >
              {feature}
            </Typography>
          </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", my: 6 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "10px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Spacious Residences
              </Typography>
              <img src={bulletpoint} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "10px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Centralized Amenities
              </Typography>
            </Box>
          
            <Box sx={{ width: "100%", height: "16px" }} />
          
            <Box sx={{ display: "flex", alignItems: "center", gap: "2px" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Green Landscapes
              </Typography>
              <img src={bulletpoint} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Ample Parking
              </Typography>
              <img src={bulletpoint} alt="2.5 BHK luxury apartment in Hyderabad by Kolla Group" style={{ width: "20px", height: "20px" }} />
              <Typography
                variant="body1"
                sx={{
                  fontSize: "9px",
                  fontFamily: "LEMON MILK",
                  fontWeight: "400",
                  color: "#d3d3d3",
                  textAlign: "center",
                  letterSpacing: 1,
                }}
              >
                Easy Navigation
              </Typography>
            </Box>
          </Box>          
          )}
        </Box>
        </Box>

      </Container>

      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </Box>
  </Box>
  );
};

export default MasterLayout;

// Add CSS animations
const styles = `
@keyframes fadeInBounce {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  50% {
    opacity: 1;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

// P01100009146














